import IdentView from './IdentView';

export default IdentView;



// WEBPACK FOOTER //
// ./src/views/ident/index.js